import { PageLayout } from '@/shared/layout/PageLayout';
import { useStockMovements } from './hooks/useStockMovements';
import { StockMovementsTable } from './components/StockMovementsTable';
import { StockMovementsToolbar } from './components/StockMovementsToolbar';
import { permissionEngine } from '@/core/permissions';
import { useAuth } from '@/core/auth/AuthContext';

export function StockMovementsPage() {
  const { profile } = useAuth();
  permissionEngine.assert(profile?.id || '', 'inventory.transactions.view');

  const {
    data,
    total,
    isLoading,
    filters,
    updateSearch,
    updateType,
    updateDateRange,
    updatePage,
  } = useStockMovements();

  return (
    <PageLayout title="Lịch sử giao dịch" description="Theo dõi toàn bộ luồng nhập, xuất, luân chuyển và kiểm kê">
      <div className="flex flex-col h-full gap-4">
        <StockMovementsToolbar
          filters={filters}
          onSearchChange={updateSearch}
          onTypeChange={updateType}
          onDateRangeChange={updateDateRange}
        />

        <div className="flex-1 bg-white border border-slate-200 rounded-md overflow-hidden min-h-0">
          <StockMovementsTable
            items={data}
            total={total}
            page={filters.page}
            pageSize={filters.pageSize}
            isLoading={isLoading}
            onPageChange={updatePage}
          />
        </div>
      </div>
    </PageLayout>
  );
}

export default StockMovementsPage;
